// "Open on the Karan Arjun site" from the TalentCrux tab (POST /api/karan/sso/ticket).

// The dev site (dev.talentcrux.ai, and the dev branch's Vercel preview) always has the Karan
// Arjun site, so it can be tried there with no Vercel setting.
const DEV_HOSTS = ['dev.talentcrux.ai'];
const DEV_PREVIEW = /^talentcrux-git-dev-[a-z0-9-]+\.vercel\.app$/;

export function isDevHost(hostname = typeof window !== 'undefined' ? window.location.hostname : '') {
  const host = String(hostname || '').toLowerCase();
  return DEV_HOSTS.includes(host) || DEV_PREVIEW.test(host);
}

// The site is src/pages/jodi in this same build (App.js uses this too): always in development
// and on the dev site; anywhere else a production build includes it only with
// REACT_APP_ENABLE_JODI=true.
export const SITE_IN_BUILD =
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_ENABLE_JODI === 'true' || isDevHost();

/**
 * Follow the ticket answer `{ url, sameOrigin }`. Same origin: an in-app path, so just navigate
 * (the browser already holds the session). Another origin: a one-time ticket link, so leave the
 * app. Returns false when there is nowhere to go (no url, or the site is not in this build).
 */
export function followSiteUrl(result, navigate, assign = (url) => window.location.assign(url)) {
  const url = typeof result?.url === 'string' ? result.url : '';
  if (result?.sameOrigin) {
    if (!SITE_IN_BUILD || !url.startsWith('/') || url.startsWith('//')) return false;
    navigate(url);
    return true;
  }
  if (!/^https?:\/\//i.test(url)) return false;
  assign(url);
  return true;
}
